import * as React from 'react';

export function SvgGoogleCalendarLogo(props: any) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path
        d="M2 17.385h4.744V6.744h10.64V2H4.373C2.79 2 2 2.748 2 4.244"
        fill="#4285F4"
      ></path>
      <path
        d="M17.256 2v4.872H22V4.244C22 2.748 21.252 2 19.756 2"
        fill="#1967D2"
      ></path>
      <path d="M17.256 6.744H22v10.512h-4.744" fill="#FBBC04"></path>
      <path
        d="M2 17.256v2.5C2 21.252 2.748 22 4.244 22h2.628v-4.744"
        fill="#188038"
      ></path>
      <path d="M6.744 17.256h10.512V22H6.744" fill="#34A853"></path>
      <path d="M17.256 22v-4.744H22" fill="#EA4335"></path>
      <path
        d="m12.92 12.568-.895-.21.294-2.484h2.841v.875h-1.923l-.11.965c.053-.032.144-.068.27-.11.13-.045.272-.067.428-.067.24 0 .453.036.638.11.187.071.345.177.474.317.129.138.226.308.29.51.067.203.1.435.1.695 0 .21-.034.412-.103.608a1.482 1.482 0 0 1-.835.891 1.928 1.928 0 0 1-.751.134c-.216 0-.426-.034-.631-.1a1.873 1.873 0 0 1-.554-.287 1.439 1.439 0 0 1-.388-.458 1.265 1.265 0 0 1-.136-.604h1.131c.007.118.035.22.084.307a.542.542 0 0 0 .197.204c.084.046.181.07.29.07a.527.527 0 0 0 .277-.067.476.476 0 0 0 .174-.184.878.878 0 0 0 .09-.267 1.89 1.89 0 0 0 .027-.324c0-.12-.014-.228-.04-.323a.611.611 0 0 0-.12-.244.523.523 0 0 0-.217-.157.826.826 0 0 0-.314-.053.75.75 0 0 0-.384.083.678.678 0 0 0-.204.17ZM11.29 9.607v5.128h-1.188v-3.79l-1.169.342v-.902l2.247-.778h.11Z"
        fill="#1967D2"
      ></path>
    </svg>
  );
}
